module.exports = __webpack_public_path__ + "img/recapBanner-part5.d4e37538.svg";